var sistemas = $('#interna-cadastro');

if (sistemas.length>0){
    jQuery("input[name='postcode']").blur(function() {
        var cep = this.value.replace(/\D/g, '');
        var valido = (cep.length == 8);

        if (valido) {
            $('#address .text-danger').remove();
            $.ajax({
                url: "https://viacep.com.br/ws/" + cep + "/json/",
                type: 'get',
                dataType: 'json',
                timeout: 5000,
                beforeSend: function(){
                    $('input[name="address_1"], input[name="address_2"], input[name="city"], select[name="zone_id"]').attr('disabled', true);
                    $("input[name='postcode']").before(' <i class="fas fa-circle-notch fa-spin"></i> ');
                },
                complete: function(){
                    $('input[name="address_1"], input[name="address_2"], input[name="city"], select[name="zone_id"]').attr('disabled', false);
                    $('.fa-spin').remove();
                },
                success: function(json) {
                    if (json['message']) {
                        $("input[name='postcode']").after('<span class="text-danger">'+json['message']+'</span>');
                    } else {
                        $('input[name="address_1"]').val(json['logradouro']);
                        $('input[name="address_2"]').val(json['bairro']);
                        $('input[name="city"]').val(json['localidade']);
                        $("select[name='zone_id'] option[title='"+json["uf"]+"']").attr('selected', true);
                    }
                    var inputs = $('#address .col-md-6:visible input'),
                        total = inputs.length, i=0;
                    for (i=0; i<total; i++) {
                        if (inputs[i].value == "") {
                            inputs[i].focus();
                            break;
                        }
                    }
                }
            });
        }
    });


    $('#account .col-md-6[data-sort]').detach().each(function() {
        if ($(this).attr('data-sort') >= 0 && $(this).attr('data-sort') <= $('#account .col-md-6').length) {
            $('#account .col-md-6').eq($(this).attr('data-sort')).before(this);
        }

        if ($(this).attr('data-sort') > $('#account .col-md-6').length) {
            $('#account .col-md-6:last').after(this);
        }

        if ($(this).attr('data-sort') == $('#account .col-md-6').length) {
            $('#account .col-md-6:last').after(this);
        }

        if ($(this).attr('data-sort') < -$('#account .col-md-6').length) {
            $('#account .col-md-6:first').before(this);
        }
    });

    $('#address .col-md-6[data-sort]').detach().each(function() {
        if ($(this).attr('data-sort') >= 0 && $(this).attr('data-sort') <= $('#address .col-md-6').length) {
            $('#address .col-md-6').eq($(this).attr('data-sort')).before(this);
        }

        if ($(this).attr('data-sort') > $('#address .col-md-6').length) {
            $('#address .col-md-6:last').after(this);
        }

        if ($(this).attr('data-sort') == $('#address .col-md-6').length) {
            $('#address .col-md-6:last').after(this);
        }

        if ($(this).attr('data-sort') < -$('#address .col-md-6').length) {
            $('#address .col-md-6:first').before(this);
        }
    });

    setTimeout(function() {
        $('.col-md-6 :input[data-error]').each(function(){
            var msg = $(this).data('error');
            if (msg != "") {
                notification.error(msg, true);
            }
        });
    }, 500);

    $('input[name=\'customer_group_id\']').on('change', function() {

        //Substitui o placeholder dos campos pj
        if (this.value == 2) {
            $('#fg-firstname label').text('Nome da Empresa');
            $('#fg-firstname input').attr("placeholder", 'Nome da Empresa*');
            $('#fg-lastname label').text('Razão Social');
            $('#fg-lastname input').attr("placeholder", 'Razão Social*');
        } else {
            $('#fg-firstname label').text('Nome');
            $('#fg-firstname input').attr("placeholder", 'Nome*');
            $('#fg-lastname label').text('Sobrenome (Obrigatório)');
            $('#fg-lastname input').attr("placeholder", 'Sobrenome*');
        }

        $.ajax({
            url: 'index.php?route=account/register/customfield&customer_group_id=' + this.value,
            dataType: 'json',
            success: function(json) {
                $('.custom-field').hide();
                $('.custom-field').removeClass('required');

                for (i = 0; i < json.length; i++) {
                    custom_field = json[i];

                    $('[data-id="custom-field' + custom_field['custom_field_id'] + '"]').show();

                    if (custom_field['required']) {
                        $('[data-id="custom-field' + custom_field['custom_field_id'] + '"]').addClass('required');
                    }
                }


            },
            error: function(xhr, ajaxOptions, thrownError) {
                alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
            }
        });
    });
    $('input[name=\'customer_group_id\']:checked').trigger('change');
    $('select[name=\'country_id\']').on('change', function() {
        $.ajax({
            url: 'index.php?route=account/account/country&country_id=' + this.value,
            dataType: 'json',
            beforeSend: function() {
                $('select[name=\'country_id\']').after(' <i class="fa fa-circle-o-notch fa-spin"></i>');
            },
            complete: function() {
                $('.fa-spin').remove();
            },
            success: function(json) {
                if (json['postcode_required'] == '1') {
                    $('input[name=\'postcode\']').parent().parent().addClass('required');
                } else {
                    $('input[name=\'postcode\']').parent().parent().removeClass('required');
                }

                html = '<option value="">Estado*</option>';

                if (json['zone'] && json['zone'] != '') {
                    for (i = 0; i < json['zone'].length; i++) {
                        html += '<option value="' + json['zone'][i]['zone_id'] + '"';

                        if (json['zone'][i]['zone_id'] == '<?php echo $zone_id; ?>') {
                            html += ' selected="selected"';
                        }

                        html += ' title="' + json['zone'][i]['code'] + '">' + json['zone'][i]['name'] + '</option>';
                    }
                } else {
                    html += '<option value="0" selected="selected"><?php echo $text_none; ?></option>';
                }

                $('select[name=\'zone_id\']').html(html);
            },
            error: function(xhr, ajaxOptions, thrownError) {
                alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
            }
        });
    });

    $('select[name=\'country_id\']').trigger('change');
}